import { MultipleSelect } from './MultipleSelect.main';

export { MultipleSelect };
